import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'star-rating',
    templateUrl: './star.component.html',
    styleUrls: ['./star.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarComponent implements OnInit {
  @Input() rating: number;
  @Output() ratingClick: EventEmitter<any> = new EventEmitter<any>();

  inputName: string;
  ngOnInit() {
    this.inputName = '_rating';
  }
  onClick(rating: number): void {
    this.rating = rating;
    this.ratingClick.emit({
         rating: rating
    });
  }
}